import Footer from "components/footer/FooterAuthDefault";
import signIn from "assets/img/atrium/signimage.png";
import AtriumLogo from "layouts/auth/AtriumLogo";

function Default({ maincard }) {
  return (
    <div className="relative block w-full bg-canvas text-fg xl:flex xl:flex-row">
      <div className="flex min-h-[100dvh] flex-1 flex-col items-center">
        <div className="flex w-full flex-1 flex-col px-4 md:max-w-[420px]">
          <AtriumLogo className="mt-8" />

          <div className="flex flex-1 items-center justify-center py-10">
            {maincard}
          </div>
        </div>

        <div className="pb-6">
          <Footer />
        </div>
      </div>

      <div className="relative hidden max-h-screen w-[45%] xl:block">
        <img alt="" src={signIn} className="h-full w-full object-cover" />
        <figure className="absolute bottom-4 left-4 right-4 rounded-control bg-black/50 p-4 text-sm font-medium text-white md:text-base">
          <blockquote>
            “Atrium AI is pioneering a new era in church engagement, turning raw
            data into real ministry insights. It’s one of the most missionally
            aligned platforms we’ve seen.”
          </blockquote>
          <figcaption className="mt-2 text-center font-semibold">
            Amar Patel, Missional Labs
          </figcaption>
        </figure>
      </div>
    </div>
  );
}

export default Default;
